export { SectionTypes } from '../constants';
export const sectionsPropertyKeys = {
    text: {
        textVisible: 'label-display',
        font: 'font',
        color: 'color',
        letterSpacing: 'letter-spacing',
        textDecoration: 'text-decoration',
        direction: 'direction',
        textAlign: 'text-align',
        textHighlight: 'text-highlight',
        textTransform: 'text-transform',
        textOutline: 'text-outline',
        textShadow: 'text-shadow',
        lineHeight: 'line-height',
    },
    border: {
        top: 'border-top',
        right: 'border-right',
        bottom: 'border-bottom',
        left: 'border-left',
    },
    corner: {
        borderTopLeftRadius: 'border-top-left-radius',
        borderTopRightRadius: 'border-top-right-radius',
        borderBottomLeftRadius: 'border-bottom-left-radius',
        borderBottomRightRadius: 'border-bottom-right-radius',
    },
    padding: {
        paddingLeft: 'padding-left',
        paddingRight: 'padding-right',
        paddingTop: 'padding-top',
        paddingBottom: 'padding-bottom',
    },
    icon: {
        iconSize: 'icon-size',
        iconColor: 'icon-color',
        iconRotation: 'icon-rotation',
        iconEnabled: 'icon-display',
    },
};
//# sourceMappingURL=constants.js.map